import { getDataGridStyles } from '../../Interface/Datagrid/dataGridStyles';

export const getTableReportStyles = (theme, height, rowHeight = 45) => {
  const singleLineHeaderHeight = Math.max(34, rowHeight - 1);
  const headerHeight = Math.max(42, singleLineHeaderHeight + 6);
  const headerFilterHeight = Math.max(34, rowHeight - 2);

  return {
    ...getDataGridStyles(theme, { height: height ? height - 50 : 550 }),
    '& .MuiDataGrid-row': {
      margin: 0,
    },
    '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell, &.MuiDataGrid-root--densityCompact .MuiDataGrid-cellContent, &.MuiDataGrid-root--densityCompact .MuiDataGrid-headerFilterRow input, &.MuiDataGrid-root--densityCompact .MuiDataGrid-headerFilterRow .MuiSelect-select, &.MuiDataGrid-root--densityCompact .MuiDataGrid-headerFilterRow .MuiFormLabel-root':
      {
        fontSize: '12.25px',
      },
    '&.MuiDataGrid-root--densityCompact .MuiDataGrid-columnHeaderTitle': {
      fontSize: '12.25px',
    },
    '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell, &.MuiDataGrid-root--densityStandard .MuiDataGrid-cellContent, &.MuiDataGrid-root--densityStandard .MuiDataGrid-headerFilterRow input, &.MuiDataGrid-root--densityStandard .MuiDataGrid-headerFilterRow .MuiSelect-select, &.MuiDataGrid-root--densityStandard .MuiDataGrid-headerFilterRow .MuiFormLabel-root':
      {
        fontSize: '13px',
      },
    '&.MuiDataGrid-root--densityStandard .MuiDataGrid-columnHeaderTitle': {
      fontSize: '13px',
    },
    '&.MuiDataGrid-root--densityStandard .MuiDataGrid-columnHeader': {
      paddingLeft: '3px',
      paddingRight: '3px',
    },
    '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell, &.MuiDataGrid-root--densityComfortable .MuiDataGrid-cellContent, &.MuiDataGrid-root--densityComfortable .MuiDataGrid-headerFilterRow input, &.MuiDataGrid-root--densityComfortable .MuiDataGrid-headerFilterRow .MuiSelect-select, &.MuiDataGrid-root--densityComfortable .MuiDataGrid-headerFilterRow .MuiFormLabel-root':
      {
        fontSize: '13.75px',
      },
    '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-columnHeaderTitle': {
      fontSize: '13.75px',
    },
    '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-columnHeader': {
      paddingLeft: '3px',
      paddingRight: '3px',
    },
    '& .MuiDataGrid-cell': {
      paddingTop: '2px',
      paddingBottom: '2px',
      paddingLeft: '6px',
      paddingRight: '6px',
    },
    '& .MuiDataGrid-cellContent': {
      margin: 0,
      lineHeight: 1.2,
    },
    '& .MuiDataGrid-columnHeader': {
      minHeight: `${headerHeight}px !important`,
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: '4px',
      paddingRight: '4px',
    },
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      alignItems: 'center',
      height: '100%',
      paddingTop: 0,
      paddingBottom: 0,
      overflow: 'hidden',
    },
    '& .MuiDataGrid-columnHeaderTitleContainerContent': {
      alignItems: 'center',
      margin: 0,
      paddingTop: 0,
      paddingBottom: 0,
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      whiteSpace: 'normal',
      lineHeight: 1.15,
      margin: 0,
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-word',
      overflowWrap: 'anywhere',
      hyphens: 'auto',
    },
    '& .MuiDataGrid-headerFilterRow .MuiDataGrid-columnHeader': {
      minHeight: `${headerFilterHeight}px !important`,
      paddingBottom: '4px',
      backgroundColor: theme.palette.ui.dgFilterRow,
    },
    '& .MuiDataGrid-headerFilterRow .MuiFormControl-root': {
      margin: 0,
    },
    '& .MuiDataGrid-footerContainer': {
      minHeight: '36px',
    },
    '& .MuiTablePagination-root': {
      fontSize: '0.75rem',
    },
    '& .MuiTablePagination-toolbar': {
      minHeight: '36px',
      paddingLeft: '6px',
      paddingRight: '6px',
    },
    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
      margin: 0,
      fontSize: '0.75rem',
    },
    '& .MuiTablePagination-select': {
      marginRight: '4px',
      fontSize: '0.75rem',
    },
    '& .MuiTablePagination-actions .MuiIconButton-root': {
      padding: '4px',
      margin: 0,
    },
    '& .MuiDataGrid-selectedRowCount': {
      fontSize: '0.75rem',
      margin: 0,
      lineHeight: 1.2,
    },
  };
};
